import { render, staticRenderFns } from "./ButtonsSection.vue?vue&type=template&id=b1b72440"
import script from "./ButtonsSection.vue?vue&type=script&lang=js"
export * from "./ButtonsSection.vue?vue&type=script&lang=js"
import style0 from "./ButtonsSection.vue?vue&type=style&index=0&id=b1b72440&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports